export const ADMIN = 1
export const MULTILOCATION = 30

//growers
export const GROWER = 6
export const FRONTLINEEMPLOYEEGROWERSALES = 31
export const FRONTLINEEMPLOYEEGROWERBATCHES = 32
export const ASSTMANAGERCULTIVATOR = 22
export const MANAGERCULTIVATOR = 23
export const GROWERMARKETPLACE = 27

//processers
export const PROCESSOR = 7
export const FRONTLINEEMPLOYEE = 19
export const ASSTMANAGERPROCESSOR = 24
export const MANAGERPROCESSOR = 25
export const PROCESSORMARKETPLACE = 29

//both grower and processer front-line employee

//retailers
export const RETAILER = 11
export const ASSTMANAGERRETAILER = 20
export const MANAGERRETAILER = 21
export const FRONTLINEEMPLOYEERETAILER = 26
export const DEMORETAILER = 36

export const LABADMIN = 10

export const GROWER_SUB_USER = [6, 31, 32, 22, 23, 27]
export const PROCESSOR_SUB_USER = [7, 19, 24, 25, 29]
export const RETAILER_SUB_USER = [11, 20, 21, 26, 28]
